<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left" />
      </f7-nav-left>
      <f7-nav-title>營業時間管理</f7-nav-title>
    </f7-navbar>

    <f7-list media-list>
      <f7-list-item title="已發佈菜單" divider />
      <f7-list-item
        v-for="(menu, index) in menuVariations"
        :key="`business-hours-released-menu-variations-${index}`"
        :link="`/stores/${storeIdProp}/menu-time-settings/${menu.variation}`"
        :title="`${menu.variationTitle}`"
        :subtitle="menu.variation"
        :after="`目前版本: ${menu.version}`" />
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      menuList: []
    }
  },
  computed: {
    ...mapState('menuModule', ['menuVariations']),
    ...mapGetters(['storeId'])
  },
  async created () {
    if (!this.storeId) {
      await this.setStore(this.storeIdProp)
    }
    // TODO: 檢查是否已經有值，如果已經下載過就不用再下載？
    this.getMenuVariations()
  },
  props: {
    storeIdProp: String
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('menuModule', ['getMenuVariations'])
  }
}
</script>
